'use client';

import styled from 'styled-components';
import Link from 'next/link';
import {
  FabButton,
  Flex,
  HeaderText,
  MEDIA_QUERY_LARGE,
  MEDIA_QUERY_MOBILE,
  Paragraph,
  rowStyles,
} from 'bouqei';
// import DraftTableOfContents from './DraftTableOfContents';
import zIndex from '#/lib/zIndex';
import { useState } from 'react';
import colors from '#/lib/colors';
import useGuide from '#/hooks/useGuide';
import { ChevronLeft, ChevronRight, Menu, Replay } from '@mui/icons-material';
import { useShell } from '#/context/ShellContext';
import { poppins, quest } from '#/utils/fonts';
import Image from 'next/image';
import { usePathname } from 'next/navigation';

enum StatusState {
  Next = 'next',
  Prev = 'prev',
  Current = 'current',
}

const DraftHeader = () => {
  const { next, prev, current } = useGuide();
  const { setShowSidebar } = useShell();
  const [status, setStatus] = useState(StatusState.Current);
  const pathname = usePathname();
  const isReport = pathname.includes('reports/');

  return (
    <Wrapper>
      <ToggleSidebar
        size="small"
        format="primary"
        $transparent
        onClick={() => setShowSidebar(open => !open)}
      >
        <Menu />
      </ToggleSidebar>
      {!isReport ? (
        <PageTitle
          type={6}
          className={poppins.className}
          weight={600}
          style={{ textTransform: 'uppercase', color: colors.primary }}
          format="dark"
        >
          {current.title || 'Intro'}
        </PageTitle>
      ) : (
        <PageTitle
          type={6}
          className={poppins.className}
          weight={600}
          style={{ textTransform: 'uppercase', color: colors.primary }}
          format="dark"
        >
          Scouting Report
        </PageTitle>
      )}
      {/* <DraftTableOfContents format="light" /> */}

      <Brand>
        <Link className="brand-link" href="/draft">
          <Image
            src="/images/badlands_outline.png"
            width="1680"
            height="721"
            alt="TOJ Badlands"
          />
        </Link>
      </Brand>
      <Flex
        gap="16px"
        justifyContent="flex-end"
        alignItems="center"
        style={{ flex: 1 }}
      >
        {current && (
          <Paragraph
            className={`${status} status ${quest.className}`}
            format="dark"
            weight={500}
          >
            {status === StatusState.Next ? `NEXT: ${next.title}` : ''}
            {status === StatusState.Prev ? `PREV: ${prev.title}` : ''}
          </Paragraph>
        )}
        {prev && prev.route && (
          <Link href={prev.route}>
            <FabButton
              title={prev.title}
              onMouseOver={() => setStatus(StatusState.Prev)}
              onMouseOut={() => setStatus(StatusState.Current)}
              format="secondary"
              size="small"
            >
              <ChevronLeft />
            </FabButton>
          </Link>
        )}
        {next && next.route && (
          <Link href={next.route}>
            <FabButton
              title={next.title}
              onMouseOver={() => setStatus(StatusState.Next)}
              onMouseOut={() => setStatus(StatusState.Current)}
              size="small"
              format="secondary"
            >
              <ChevronRight />
            </FabButton>
          </Link>
        )}
        {!next?.route && (
          <Link href="/draft">
            <FabButton fab format="secondary" size="small">
              <Replay />
            </FabButton>
          </Link>
        )}
      </Flex>
    </Wrapper>
  );
};

export default DraftHeader;

export const HEADER_HEIGHT = '65px';

const Wrapper = styled.header`
  width: 100%;
  position: sticky;
  top: 0;
  z-index: ${zIndex.Header};
  height: ${HEADER_HEIGHT};
  padding: 0 16px;
  /* transition: background-color 0.5s ease-in-out; */
  background-color: ${colors.white};
  border-bottom: solid 1px ${colors.grey};
  ${rowStyles('flex-start', 'center')}
  overflow: hidden;

  @media ${MEDIA_QUERY_MOBILE} {
    .status {
      display: none;
    }
  }
`;

const ToggleSidebar = styled(FabButton)`
  display: none;

  @media ${MEDIA_QUERY_LARGE} {
    display: inline-block;
  }
`;

const Brand = styled.div`
  display: none;
  position: relative;
  height: 100%;

  img {
    width: auto;
    height: 100%;
  }

  @media ${MEDIA_QUERY_MOBILE} {
    display: block;
  }
`;

const PageTitle = styled(HeaderText)`
  @media ${MEDIA_QUERY_MOBILE} {
    display: none;
  }
`;
